<template>
  <div>
    <button class="add-item" v-if="!mode.add && currentWidget.type !== 'hero' && currentWidget.type !== 'author-carousel'" @click="addItem">Add Item</button>
    <latest-story-preview
      v-if="currentWidget.type ==='top-stories'"
      :selectedItem="selectedItem"
      :currentWidget="currentWidget"
      @orderChange="orderChange"
      :mode="mode"
      :storage="storage"
    />
    <latest-story-preview
      v-if="currentWidget.type ==='vertical-article-block'"
      :selectedItem="selectedItem"
      :currentWidget="currentWidget"
      @orderChange="orderChange"
      :mode="mode"
      :storage="storage"
    />
    <lifestyle-preview
      v-if="currentWidget.type ==='three-row-column'"
      :selectedItem="selectedItem"
      :currentWidget="currentWidget"
      @orderChange="orderChange"
      :mode="mode"
      :maxItems="3"
      :storage="storage"
    />
    <author-carousel
      v-if="currentWidget.type ==='author-carousel'"
      :selectedItem="selectedItem"
      :currentWidget="currentWidget"
      @orderChange="orderChange"
      @setWidgetData="$emit('setWidgetData',$event)" 
      :mode="mode"
      :maxItems="20"
      :storage="storage"
    />
  </div>
</template>

<script>
import authorCarousel from "./widgets/authorCarousel";
import latestStoryPreview from "./widgets/latestStoryPreview";
import lifestylePreview from "./widgets/lifestylePreview";
export default {
  props: [
    "currentWidget",
    "selectedItem",
    "newWidgetOrder",
    "mode",
    "storage"
  ],
  components: {
    authorCarousel,
    latestStoryPreview,
    lifestylePreview
  },
  mounted() {
    if (this.mode.add && this.selectedItem.slug.length > 0) {
      // Only going to work if one child appears
      this.$children[0].newItem();
      this.mode.add = false;
      this.mode.edit = true;
    }
  },
  methods: {
    orderChange: function(e) {
      this.$emit("reorder", e);
    },
    addItem: function() {
      this.mode.add = true;
    }
  },
  watch: {
    selectedItem: function() {
      this.$nextTick(() => {
        if (this.selectedItem.slug.length > 0) {
          this.$children[0].newItem();
          this.mode.add = false;
          this.mode.edit = true;
        }
      });
    }
  }
};
</script>

<style scoped>
.add-item {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// ModalMultiArticle.vue?d34fde56